import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function AdaptabilitySection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const businessTypes = ['One Restaurant', 'A Café', 'A Deli', 'Multiple Locations'];
  const handlePrevious = () => {
    setCurrentIndex(prev => prev === 0 ? businessTypes.length - 1 : prev - 1);
  };
  const handleNext = () => {
    setCurrentIndex(prev => prev === businessTypes.length - 1 ? 0 : prev + 1);
  };
  return <section className="bg-white px-6 py-16 border-t border-gray-100" data-id="element-1">
      <div className="max-w-2xl mx-auto space-y-8" data-id="element-2">
        <div className="text-center" data-id="element-3">
          <h2 className="text-slate-navy text-3xl font-manrope font-semibold" data-id="element-4">
            Built for Speed
          </h2>
        </div>

        <div className="relative bg-gray-50 rounded-[8px] p-6 border border-gray-200" data-id="element-5">
          <AnimatePresence mode="wait" data-id="element-6">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.2
          }} className="text-center py-8" data-id="element-7">
              <h3 className="text-slate-navy text-2xl font-manrope font-semibold" data-id="element-8">
                {businessTypes[currentIndex]}
              </h3>
            </motion.div>
          </AnimatePresence>

          <div className="flex items-center justify-between mt-4" data-id="element-9">
            <button onClick={handlePrevious} className="w-10 h-10 bg-white border border-gray-200 rounded-[8px] flex items-center justify-center hover:bg-gray-50 transition-colors" aria-label="Previous business type" data-id="element-10">
              <ChevronLeftIcon className="w-5 h-5 text-slate-navy" data-id="element-11" />
            </button>

            <div className="flex gap-2" data-id="element-12">
              {businessTypes.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-1.5 rounded-full transition-all ${index === currentIndex ? 'bg-slate-navy w-6' : 'bg-gray-300 w-1.5'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-13" />)}
            </div>

            <button onClick={handleNext} className="w-10 h-10 bg-white border border-gray-200 rounded-[8px] flex items-center justify-center hover:bg-gray-50 transition-colors" aria-label="Next business type" data-id="element-14">
              <ChevronRightIcon className="w-5 h-5 text-slate-navy" data-id="element-15" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}